export default __webpack_public_path__ + "static/media/atatianaJefferson.5d26e582.png";